export default __webpack_public_path__ + "static/media/on.de224e70.svg";